var map = {
	"./de-DE.ts": [
		7163,
		544
	],
	"./en-US.ts": [
		9223
	],
	"./es-ES.ts": [
		8542,
		542
	],
	"./fr-FR.ts": [
		4406,
		406
	],
	"./ja-JP.ts": [
		5279,
		279
	],
	"./ko-KR.ts": [
		1709,
		709
	],
	"./pt-PT.ts": [
		522,
		522
	],
	"./ru-RU.ts": [
		5360,
		360
	],
	"./zh-CN.ts": [
		7585
	],
	"./zh-TW.ts": [
		6497,
		497
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 109;
module.exports = webpackAsyncContext;